import { translate } from '@focaltec-suite/core'

export interface Product {
    id: string
    imageUrl: string
    imageAlt(): string
    redirectUrl: string
}

export const products: Product[] = [
    {
        id: 'admin',
        imageAlt: () => translate('apps.admin') as string,
        imageUrl: '/focaltec_horizontal.png',
        redirectUrl: process.env.REACT_APP_ADMIN_URL!,
    },
    {
        id: 'cdg',
        imageAlt: () => translate('apps.cdg') as string,
        imageUrl: '/focaltec_horizontal.png',
        redirectUrl: process.env.REACT_APP_CDG_URL!,
    },
    {
        id: 'budgets',
        imageAlt: () => translate('apps.budgets') as string,
        imageUrl: '/focaltec_horizontal.png',
        redirectUrl: process.env.REACT_APP_BUDGETS_URL!,
    },
    {
        id: 'requisitions',
        imageAlt: () => translate('apps.requisitions') as string,
        imageUrl: '/focaltec_horizontal.png',
        redirectUrl: process.env.REACT_APP_REQUISITIONS_URL!,
    },
]

export function getProductByRedirectUrl(redirect: string): Product | undefined {
    return products.find((r) => redirect.indexOf(r.redirectUrl) !== -1)
}
